// @flow
import { takeEvery, put, call } from 'redux-saga/effects';

import { getArrayResource } from '@redux/components/ApiRequest/actions';

import { isEmpty } from 'lodash';
import { mainApiUrl } from '@lib';

import { Elastic_SEARCH_REQUEST } from './constants';
import { errorElasticSearch, updateElasticSearch } from './actions';

import type { Action } from '../types';

export function* getResourceActionForSearchBar({ query }: Action): Generator<Function, void, void> {
  const backendQuery: {} = {
    query: isEmpty(query) ? undefined : query
  };

  const url: string = `${mainApiUrl}/v1/search`;

  yield put(
    getArrayResource(url, updateElasticSearch, errorElasticSearch, {
      params: {
        ...backendQuery
      }
    })
  );

  if (typeof window !== 'undefined') {
    yield call(window.scrollTo, 0, 0);
  }
}

export function* ElasticSearchFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case Elastic_SEARCH_REQUEST:
      yield call(getResourceActionForSearchBar, action.requestPayload);
      break;
    default:
      break;
  }
}

function* ElasticSearchWatcher(): Generator<Function, void, Action> {
  yield takeEvery([Elastic_SEARCH_REQUEST], ElasticSearchFlow);
}

export default ElasticSearchWatcher;
